import React from "react";
import { Grid, Box, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import {
  ModernLiquidTable,
} from "../../../components/modern-table";
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import { getVolunteers } from "../../../api/msf";
import exportToExcel from "../../../utils/exportToExcel";

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: currentYear - 2022 }, (_, i) => currentYear - i);

export default function ListVolunteerPage() {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState(currentYear);

  const fetchData = React.useCallback(async () => {
    setLoading(true);
    try {
      const data = await getVolunteers(year);
      if (data) {
        setRows(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [year]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      field: "_rowNumber",
      title: "No",
      width: 50,
      render: (rowData) => <p>{rowData._rowNumber}</p>,
    },
    { field: "name", title: "Nama", width: 200 },
    { field: "nationalId", title: "No. KP" },
    { field: "email", title: "E-mel" },
    { field: "phone", title: "No Tel" },
    { field: "volunteerCategory", title: "Kategori Sukarelawan" },
    { field: "state", title: "Negeri" },
    { field: "address", title: "Kawasan" },
    { field: "bazar", title: "Lokasi Bazar" },
    {
      field: "createdAt",
      title: "Tarikh Daftar",
      render: (rowData) =>
        rowData.createdAt
          ? new Date(rowData.createdAt).toLocaleDateString("ms-MY")
          : "-",
    },
  ];

  const handleExport = (columns, data) => {
    const st = data.map((v) => ({
      Nama: v.name,
      No_KP: v.nationalId,
      Emel: v.email,
      No_Tel: v.phone,
      Negeri: v.state,
      Jantina: v.gender,
      Bangsa: v.race,
      Agama: v.religion,
      Umur: v.age,
      Pendidikan: v.education,
      Pekerjaan: v.occupation,
      Kategori_Sukarelawan: v.volunteerCategory,
      Kawasan: v.address,
      Lokasi_Bazar: v.bazar,
      Tarikh_Daftar: v.createdAt
        ? new Date(v.createdAt).toLocaleDateString("ms-MY")
        : "-",
    }));
    exportToExcel(st);
  };

  return (
    <Portlet>
      <PortletBody fluid={true}>
        <Grid className="p-3" container spacing={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                mb: 2,
                p: 2,
                background:
                  "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
                borderRadius: "12px",
                backdropFilter: "blur(10px)",
              }}
            >
              <span className="kt-section__sub">
                Senarai sukarelawan MySaveFood yang telah mendaftar untuk tahun
                semasa.
              </span>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <ModernLiquidTable
              columns={columns}
              data={rows}
              title={`Bilangan sukarelawan: ${rows.length}`}
              loading={loading}
              onRefresh={fetchData}
              exportFunction={handleExport}
              emptyStateMessage="Tiada sukarelawan berdaftar"
              customToolbarActions={
                <FormControl size="small" sx={{ minWidth: 100 }}>
                  <InputLabel>Tahun</InputLabel>
                  <Select
                    value={year}
                    label="Tahun"
                    onChange={(e) => setYear(e.target.value)}
                  >
                    {yearOptions.map((y) => (
                      <MenuItem key={y} value={y}>{y}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              }
              options={{
                selection: false,
                actionsColumnIndex: -1,
                pageSize: 10,
                pageSizeOptions: [5, 10, 20, 50],
              }}
            />
          </Grid>
        </Grid>
      </PortletBody>
    </Portlet>
  );
}
